import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ListingForm from '../../../components/forms/ListingForm';
import { useListingApi } from '../../../hooks/useListingApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ListingDTO } from '../../../services/apiClient';

const ListingEdit: React.FC = () => {
  const { getById, edit, isLoading } = useListingApi();
  const [entityData, setEntityData] = useState<ListingDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Listings', href: '/admin/listings' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Listing data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating Listing:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/listings"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Listing.Edit'
    >
        {entityData ? (
          <ListingForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate(-1)}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ListingEdit;